module.exports = __webpack_public_path__ + "img/order.9b22751d.svg";